module.exports = __webpack_public_path__ + "img/harvest_stop.bce14e0d.svg";